<template>
  <v-dialog
    v-model="isModalVisible"
    width="700"
    content-class="add-section-modal"
    @click:outside="modalClose"
  >
    <v-card>
      <v-card-title>
        <h2>
          Add new section
        </h2>
        <v-btn
          fab
          text
          small
          class="close-button"
          @click="modalClose"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pr-4">
        <div class="d-flex jcsb py-4">
          <span>Name</span>
          <input type="text" v-model="section.name" class="section-name-input">
        </div>
        <div
          v-if="options.accountsToWatch.length > 0"
          class="d-flex flex-column jcsb py-4"
        >
          <span>Position</span>
          <div class="flex row jcsb py-2">
            <v-select
              :items="options.position"
              label="Select position"
              class="position-select px-3"
            />
            <v-select
              :items="options.accountsToWatch"
              label="Accounts to watch"
              class="watch-accounts-select"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-4">
        <v-spacer />
        <v-btn
          depressed
          dark
          color="primary"
          v-if="section.name.length > 0"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "addSection",
  props: {
    isModalVisible: Boolean
  },
  data () {
    return {
      section: {
        name: '',
        position: '',
        accountsToWatch: ''
      },
      options: {
        position: [
            'Before',
            'After'
        ],
        accountsToWatch: []
      }
    }
  },
  methods: {
    modalClose() {
      this.$emit('modalClose', false)
    }
  }
}
</script>

<style lang="sass" scoped>
.v-card__title
  h2
    color: #3a3852
  .close-button
    position: absolute
    top: 0
    right: 0
    background-color: #FFFFFF

.v-card__text
  width: 90%
  color: #7f98a5 !important

.section-name-input
  color: #7f98a5
  height: 31px
  width: 500px
  border: 1px solid rgba(60,60,60,.26)
  border-radius: 4px
  white-space: normal
  padding: 0 10px
  &:focus
   outline: none

.position-select
  width: 20%

.watch-accounts-select
  width: 60%
</style>